module.exports = __webpack_public_path__ + "media/images/team__stingergc-204fe4a430b73d4cecd9b4feb1e1a1c6.png";